import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./theme/jungleThemeColors.css";
import "./theme/jungleThemeArtwork.css";
import "katex/dist/katex.min.css";
import App from "./App";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { initializeSentryForJungleWebApp } from "./utils/analytics/sentry-init";
import { RootErrorBoundary } from "./components/RootErrorBoundary";

// Sentry uses a cost-controlled config. The previous default config (100% trace
// sampling + 10% replay sampling) was expensive. The new config in
// `utils/analytics/sentry-init.ts` runs at:
//   - tracesSampleRate: 0.1   (10× cheaper)
//   - replay disabled because uploaded documents can be rendered as pixels
//     (only records the screen when an error fires)
//   - aggressive ignoreErrors / denyUrls to filter browser-extension noise
//
// To disable again (e.g., if quota burns), comment out this call. Do NOT
// delete the sentry-init module — it preserves the cost-tuned config.
initializeSentryForJungleWebApp();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <HelmetProvider>
    <Helmet prioritizeSeoTags>
      <meta charSet="utf-8" />
      <title>Jungle - Good studying made easy</title>
      <link rel="canonical" href="https://app.jungleai.com" />
      <meta
        name="description"
        content="Become a super learner with AI flashcards & practice problems that give you personalized feedback as you learn. Generate questions from lectures, YouTube, etc."
      />
      <meta
        property="og:description"
        content="Become a super learner with AI flashcards & practice problems that give you personalized feedback as you learn. Generate questions from lectures, YouTube, etc."
      />
      <meta property="og:image" content="https://framerusercontent.com/assets/nAlbNloka1j4Xv7jOT4pR4VtnzM.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Jungle - Good studying made easy" />
      <meta
        name="twitter:description"
        content="Become a super learner with AI flashcards & practice problems that give you personalized feedback as you learn. Generate questions from lectures, YouTube, etc."
      />
      <meta name="twitter:image" content="https://framerusercontent.com/assets/nAlbNloka1j4Xv7jOT4pR4VtnzM.png" />
    </Helmet>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </HelmetProvider>
);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
